export default "__VITE_ASSET__7f972bec__"